import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface Props {
  inBody: boolean;
  child: HTMLElement;
  excludeUrls?: string[];
  appendFirst?: boolean;
}

export const useLoadScript = ({ inBody, child, excludeUrls, appendFirst }: Props) => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!excludeUrls?.find((url) => pathname.includes(url))) {
      if (inBody) {
        appendFirst ? document.body.insertBefore(child, document.body.firstChild) : document.body.appendChild(child);
      } else {
        appendFirst ? document.head.insertBefore(child, document.head.firstChild) : document.head.appendChild(child);
      }
    }
  }, []);
};
